import { useEffect, useState } from 'react';
import { View } from 'react-native';

import { COLORS, Text } from '../Basics';
import LorentzService from '../../services/LorentzService';

const formatWait = seconds => {
  const s = Math.max(0, Number(seconds) || 0);
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${String(m).padStart(2, '0')}:${String(r).padStart(2, '0')}`;
};

export const QueueBadge = () => {
  const [state, setState] = useState({ count: 0, maxWait: 0 });

  useEffect(() => {
    setState(LorentzService.getQueueState());

    const onUpdate = ev => {
      setState(ev.detail || ev.data || { count: 0, maxWait: 0 });
    };

    document.addEventListener('lorentz:queue:update', onUpdate);
    return () =>
      document.removeEventListener('lorentz:queue:update', onUpdate);
  }, []);

  if (!state.count) return null;

  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: COLORS.warning,
        paddingHorizontal: 10,
        paddingVertical: 4,
        borderRadius: 12,
        marginBottom: 6
      }}
    >
      <Text style={{ fontSize: 12, fontWeight: 'bold', color: '#333' }}>
        Fila: {state.count}
        {state.maxWait > 0 ? ` · espera ${formatWait(state.maxWait)}` : ''}
      </Text>
    </View>
  );
};

export default QueueBadge;
